"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Story = void 0;
var _react = _interopRequireWildcard(require("react"));
var _bricks = require("./bricks.js");
var _Layout = _interopRequireDefault(require("./Layout"));
var _ColorTransitions = require("./ColorTransitions");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const StoryContent = ({
  story,
  useColorTransitions,
  storyLayoutRef
}) => {
  (0, _react.useEffect)(() => {
    useColorTransitions && (0, _ColorTransitions.setupColorTransitions)(useColorTransitions, storyLayoutRef);
  }, [useColorTransitions, story]);
  return _react.default.createElement(_react.default.Fragment, null, story.map((section, index) => {
    const Section = _bricks.BRICKS.section;
    if (Section) {
      const sectionId = section.data?.id || `section--${index}`;
      return _react.default.createElement(Section, _extends({
        id: sectionId,
        key: `section--${index}`
      }, section.data), section.elements?.map((el, indexEl) => {
        const Element = _bricks.BRICKS.elements[el.type];
        if (Element) {
          return _react.default.createElement("div", {
            key: `section--${index}__element--${indexEl}`,
            id: `section--${index}__element--${indexEl}`
          }, _react.default.createElement(Element, el.data));
        } else {
          console.error(`No element ${indexEl} of type ${el.type}`);
          return null;
        }
      }));
    } else {
      console.error(`No section ${index} of type ${section.type}`);
      return null;
    }
  }));
};
const Story = ({
  story,
  useColorTransitions
}) => {
  const [progressBar, setProgressBar] = (0, _react.useState)(null);
  const [storyWithoutProgressBar, setStoryWithoutProgressBar] = (0, _react.useState)([]);
  const storyLayoutRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    setStoryWithoutProgressBar(story.map(section => {
      const elements = section.elements.filter(el => {
        if (el.type !== 'ProgressBar') {
          return el;
        }
        setProgressBar(el);
      });
      return {
        ...section,
        elements
      };
    }));
  }, []);
  return _react.default.createElement(_Layout.default, {
    ref: storyLayoutRef,
    progressBar: progressBar
  }, _react.default.createElement(StoryContent, {
    story: storyWithoutProgressBar,
    useColorTransitions: useColorTransitions,
    storyLayoutRef: storyLayoutRef
  }));
};
exports.Story = Story;
//# sourceMappingURL=Story.js.map